// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.8%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  transition: all 0.3s ease;
  padding: 1rem 0;
  background: var(--bg-white) !important;
  border-radius: 50px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1),
    inset 0 0 0 1.5px #B9B9B9;
  width: 97%;
  height: 100px;
  position: fixed;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  padding: 0 20px;
  border: none;
}

.btn-sm-ft {
  padding: 8px 15px !important;
  font-size: 12px !important;
}

.navbar-brand img {
  width: 300px;
}

.navbar-expand-sm .navbar-nav.main-menu .nav-link {
  font-size: 15px;
  font-weight: var(--font-semibold);
  color: var(--text-black);
  padding: 0 14px;
  background-color: var(--bg-white);
  text-transform: capitalize;
}

/* Login / Sign up button in header */
.navbar .btn.btn-primary,
.btn-primary-web {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 18px;
  border-radius: 50px;
  white-space: nowrap;
  flex-shrink: 0;
}

.navbar .btn.btn-primary-app {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 18px !important;
  border-radius: 50px;
  white-space: nowrap;
  flex-shrink: 0;
}

.btn-download-mobile {
  font-size: 10px !important;
  padding: 6px 10px !important;
  margin-left: auto;
  margin-right: 10px;
}

.btn-download-mobile-app {
  font-size: 10px !important;
  padding: 6px 10px !important;
  margin-left: auto;
  margin-right: 10px;
}

.navbar .container-fluid {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.navbar-expand-sm .navbar-nav.main-menu .nav-link:hover {
  color: var(--text-primary) !important;
}

/* Active navigation link styling */
.navbar-expand-sm .navbar-nav.main-menu .nav-link.active {
  color: var(--text-primary) !important;
  background-color: transparent !important;
  position: relative;
}

.login-link {
  font-size: var(--font-size-medium) !important;
  font-weight: var(--font-semibold);
  color: var(--text-primary) !important;
  background-color: var(--bg-white) !important;
}

.login-link:hover {
  color: var(--text-primary) !important;
}

/* Active login link styling */
.login-link.active {
  color: var(--text-primary) !important;
  background-color: transparent !important;
}

.login-lnk a {
  font-size: var(--font-size-medium) !important;
  font-weight: var(--font-semibold);
  color: var(--text-primary) !important;
  background-color: var(--bg-white) !important;
}

/* Profile Icon Styles */
.profile-icon {
  background: none !important;
  border: none !important;
  text-decoration: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  background-color: #a78bfa !important;
  color: white !important;
  font-size: 18px !important;
  font-weight: bold !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  margin-left: 12px !important;
  position: relative;
}

/* User Greeting Styles */
.user-greeting {
  font-size: var(--font-size-xsmall);
  font-weight: var(--font-semibold);
  color: #656565;
  margin-right: 8px;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.profile-icon::after {
  content: "Go to Dashboard";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #6218C5;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  margin-bottom: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.profile-icon:hover::after {
  opacity: 1;
  visibility: visible;
}

/* Add arrow to tooltip */
.profile-icon::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.9);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  margin-bottom: 2px;
}

.profile-icon:hover::before {
  opacity: 1;
  visibility: visible;
}

.profile-icon:hover {
  background-color: #8b5cf6 !important;
  transform: scale(1.05) !important;
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3) !important;
}

.profile-icon:focus {
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.3) !important;
}

@media (min-width: 1160px) and (max-width: 1280px) {
  .navbar-expand-sm .navbar-nav.main-menu .nav-link {
    font-size: 14px !important;
  }

  .navbar-brand img {
    width: 205px !important;
  }

  .user-greeting {
    font-size: 13px !important;
    margin-right: 0px !important;
  }

  .navbar-expand-sm .navbar-nav.main-menu .nav-link {
    padding: 0 13px !important;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .navbar-expand-sm .navbar-nav.main-menu .nav-link {
    font-size: 11px;
    font-weight: var(--font-semibold);
    padding: 0 8px;
  }

  .user-greeting {
    font-size: var(--font-x-size-small) !important;
    margin-right: 0px !important;
  }

  .login-link {
    font-size: var(--font-size-small) !important;
  }

  .navbar {
    height: 75px;
  }

  .navbar-brand img {
    width: 175px;
  }

  /* Tablet User Greeting */
  .user-greeting {
    font-size: var(--font-size-small);
    margin-right: 4px;
  }

  /* Constrain login button on tablets */
  .navbar .btn.btn-primary {
    font-size: 12px;
    padding: 6px 14px;
  }

  .navbar .btn.btn-primary-app {
    font-size: 12px;
    padding: 6px 14px;
  }
}

/* Mobile */
@media (max-width: 767px) {
  .btn-primary-app {
    padding: 8px 21px;
    font-size: 11px !important;
  }

  .btn-download-mobile-app {
    font-size: 10px !important;
    padding: 6px 14px !important;
    margin-left: auto;
    margin-right: 10px;
  }

  .btn-download-mobile-app {
    font-size: 10px !important;
    padding: 10px 10px !important;
    margin-left: auto;
    margin-right: 10px;
  }


  .navbar {
    transition: all 0.3s ease;
    padding: 1rem 0;
    background: var(--bg-white) !important;
    border-radius: 17px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 97%;
    height: 72px;
    position: fixed;
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    padding: 0px 10px 0px 16px;
  }

  .navbar-brand img {
    width: 300px;
  }

  /* Mobile Menu Icon */
  .navbar-toggler {
    display: block !important;
    border: none;
    background: transparent;
    padding: 8px;
    margin-right: 10px;
  }

  .navbar-toggler:focus {
    box-shadow: none;
    outline: none;
  }

  .navbar-toggler-icon {
    width: 24px;
    height: 24px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  /* Mobile Menu Section */
  .navbar-collapse {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: var(--bg-white);
    border-radius: 17px 17px 17px 17px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-top: 6px;
  }

  .navbar-nav {
    flex-direction: column;
    width: 100%;
  }

  .navbar-nav .nav-item {
    margin: 2px 0;
    text-align: center;
  }

  .navbar-nav .nav-link {
    font-size: var(--font-size-medium);
    font-weight: var(--font-semibold);
    color: var(--text-black);
    padding: 12px 20px;
    border-radius: 25px;
    transition: all 0.3s ease;
  }

  .navbar-nav .nav-link:hover {
    color: var(--text-primary);
    background: rgba(99, 24, 198, 0.1);
  }

  /* Mobile active navigation link styling */
  .navbar-nav .nav-link.active {
    color: var(--text-primary) !important;
    background: rgba(99, 24, 198, 0.1) !important;
    transform: none;
  }

  /* Mobile Login and Demo Button */
  .navbar-nav.ms-auto {
    margin-top: 10px;
    /* border-top: 1px solid rgba(0, 0, 0, 0.1); */
    padding-top: 0;
  }

  .navbar-nav.ms-auto .nav-item {
    padding: 10px 0;
  }

  .login-link {
    font-size: var(--font-size-medium) !important;
    font-weight: var(--font-semibold);
    color: var(--text-primary) !important;
    background-color: transparent !important;
    border: 2px solid var(--text-primary);
    border-radius: 25px;
    padding: 10px 20px !important;
    display: block;
    text-align: center;
    transition: all 0.3s ease;
    width: 50%;
  }

  .mn-auto {
    display: flex;
    justify-content: center;
  }

  .login-link:hover {
    color: var(--bg-white) !important;
    background-color: var(--text-primary) !important;
  }

  /* Mobile active login link styling */
  .login-link.active {
    color: var(--bg-white) !important;
    background-color: var(--text-primary) !important;
  }

  .btn-demo {
    background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;
    color: var(--text-white) !important;
    border: none;
    border-radius: 25px;
    padding: 12px 24px !important;
    font-size: var(--font-size-medium);
    font-weight: var(--font-semibold);
    display: block;
    text-align: center;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .btn-demo:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(99, 24, 198, 0.3);
  }

  /* Mobile Profile Icon */
  .profile-icon {
    width: 36px !important;
    height: 36px !important;
    font-size: 16px !important;
    margin-left: 4px !important;
  }

  /* Mobile User Greeting */
  .user-greeting {
    font-size: var(--font-size-small);
    margin-right: 4px;
  }

  /* Center the greeting and profile icon on mobile */
  .navbar-nav .nav-item.d-flex {
    justify-content: center;
    width: 100%;
  }

  .download-buttons-container {
    margin-top: 10px;
    margin-bottom: 5px;
  }
}

.download-btn {
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
  text-decoration: none;
}

.download-btn:hover {
  transform: scale(1.05);
}

.download-icon {
  height: 28px;
  width: auto;
  display: block;
}

@media (max-width: 991px) {
  .download-icon {
    height: 26px;
  }
}

@media (max-width: 767px) {
  .download-buttons-container {
    justify-content: center;
    width: 100%;
    margin-right: 0 !important;
  }

  .download-icon {
    height: 24px;
  }
}

@media (max-width: 575px) {
  .navbar {
    transition: all 0.3s ease;
    padding: 1rem 0;
    background: var(--bg-white) !important;
    border-radius: 17px;
    /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
    width: 97%;
    height: 56px;
    position: fixed;
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    padding: 0px 0px 0px 5px;
  }

  .navbar-brand img {
    width: 130px;
  }

  .navbar-brand {
    padding-top: 0 !important;
  }

  /* Mobile Menu Icon */
  .navbar-toggler {
    display: block !important;
    border: none;
    background: transparent;
    padding: 6px;
    margin-right: 0px;
  }

  .navbar-toggler-icon {
    width: 20px;
    height: 20px;
  }

  /* Mobile Menu Section */
  .navbar-collapse {
    padding: 15px;
  }

  .navbar-nav .nav-link {
    font-size: var(--font-15) !important;
    padding: 10px 16px;
  }

  .login-link {
    font-size: var(--font-size-small) !important;
    padding: 8px 16px !important;
  }

  .btn-demo {
    font-size: var(--font-size-small);
    padding: 10px 20px !important;
  }

  /* Mobile Profile Icon */
  .profile-icon {
    width: 32px !important;
    height: 32px !important;
    font-size: 14px !important;
    margin-left: 4px !important;
  }

  /* Mobile User Greeting */
  .user-greeting {
    font-size: var(--font-size-small);
    margin-right: 4px;
  }

  /* Center the greeting and profile icon on mobile */
  .navbar-nav .nav-item.d-flex {
    justify-content: center;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Website/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB;6BAC2B;EAC3B,UAAU;EACV,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,wBAAwB;EACxB,eAAe;EACf,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,qCAAqC;EACrC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,iCAAiC;EACjC,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA,8BAA8B;AAC9B;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,iCAAiC;EACjC,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,gCAAgC;EAChC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;EAClC,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,yDAAyD;AAC3D;;AAEA;EACE,wBAAwB;EACxB,wDAAwD;AAC1D;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;IACf,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,8CAA8C;IAC9C,4BAA4B;EAC9B;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA,yBAAyB;EACzB;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;EACpB;;;EAGA;IACE,yBAAyB;IACzB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;IACnB,yCAAyC;IACzC,UAAU;IACV,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yDAAwP;IACxP,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,kCAAkC;IAClC,yCAAyC;IACzC,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,iCAAiC;IACjC,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA,0CAA0C;EAC1C;IACE,qCAAqC;IACrC,6CAA6C;IAC7C,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;IAChB,8CAA8C;IAC9C,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6CAA6C;IAC7C,iCAAiC;IACjC,qCAAqC;IACrC,wCAAwC;IACxC,qCAAqC;IACrC,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,gDAAgD;EAClD;;EAEA,qCAAqC;EACrC;IACE,iCAAiC;IACjC,gDAAgD;EAClD;;EAEA;IACE,mGAAmG;IACnG,mCAAmC;IACnC,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,kCAAkC;IAClC,iCAAiC;IACjC,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA,wBAAwB;EACxB;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,yBAAyB;EACzB;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA,mDAAmD;EACnD;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;IACnB,+CAA+C;IAC/C,+CAA+C;IAC/C,UAAU;IACV,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,wBAAwB;EACxB;IACE,aAAa;EACf;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,4CAA4C;IAC5C,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA,wBAAwB;EACxB;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,yBAAyB;EACzB;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA,mDAAmD;EACnD;IACE,uBAAuB;IACvB,WAAW;EACb;AACF","sourcesContent":[".navbar {\n  transition: all 0.3s ease;\n  padding: 1rem 0;\n  background: var(--bg-white) !important;\n  border-radius: 50px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1),\n    inset 0 0 0 1.5px #B9B9B9;\n  width: 97%;\n  height: 100px;\n  position: fixed;\n  top: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  padding: 0 20px;\n  border: none;\n}\n\n.btn-sm-ft {\n  padding: 8px 15px !important;\n  font-size: 12px !important;\n}\n\n.navbar-brand img {\n  width: 300px;\n}\n\n.navbar-expand-sm .navbar-nav.main-menu .nav-link {\n  font-size: 15px;\n  font-weight: var(--font-semibold);\n  color: var(--text-black);\n  padding: 0 14px;\n  background-color: var(--bg-white);\n  text-transform: capitalize;\n}\n\n/* Login / Sign up button in header */\n.navbar .btn.btn-primary,\n.btn-primary-web {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px 18px;\n  border-radius: 50px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.navbar .btn.btn-primary-app {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px 18px !important;\n  border-radius: 50px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.btn-download-mobile {\n  font-size: 10px !important;\n  padding: 6px 10px !important;\n  margin-left: auto;\n  margin-right: 10px;\n}\n\n.btn-download-mobile-app {\n  font-size: 10px !important;\n  padding: 6px 10px !important;\n  margin-left: auto;\n  margin-right: 10px;\n}\n\n.navbar .container-fluid {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n\n.navbar-expand-sm .navbar-nav.main-menu .nav-link:hover {\n  color: var(--text-primary) !important;\n}\n\n/* Active navigation link styling */\n.navbar-expand-sm .navbar-nav.main-menu .nav-link.active {\n  color: var(--text-primary) !important;\n  background-color: transparent !important;\n  position: relative;\n}\n\n.login-link {\n  font-size: var(--font-size-medium) !important;\n  font-weight: var(--font-semibold);\n  color: var(--text-primary) !important;\n  background-color: var(--bg-white) !important;\n}\n\n.login-link:hover {\n  color: var(--text-primary) !important;\n}\n\n/* Active login link styling */\n.login-link.active {\n  color: var(--text-primary) !important;\n  background-color: transparent !important;\n}\n\n.login-lnk a {\n  font-size: var(--font-size-medium) !important;\n  font-weight: var(--font-semibold);\n  color: var(--text-primary) !important;\n  background-color: var(--bg-white) !important;\n}\n\n/* Profile Icon Styles */\n.profile-icon {\n  background: none !important;\n  border: none !important;\n  text-decoration: none !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 40px !important;\n  height: 40px !important;\n  border-radius: 50% !important;\n  background-color: #a78bfa !important;\n  color: white !important;\n  font-size: 18px !important;\n  font-weight: bold !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  margin-left: 12px !important;\n  position: relative;\n}\n\n/* User Greeting Styles */\n.user-greeting {\n  font-size: var(--font-size-xsmall);\n  font-weight: var(--font-semibold);\n  color: #656565;\n  margin-right: 8px;\n  white-space: nowrap;\n  transition: all 0.3s ease;\n}\n\n.profile-icon::after {\n  content: \"Go to Dashboard\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #6218C5;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  margin-bottom: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.profile-icon:hover::after {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Add arrow to tooltip */\n.profile-icon::before {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: rgba(0, 0, 0, 0.9);\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  margin-bottom: 2px;\n}\n\n.profile-icon:hover::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n.profile-icon:hover {\n  background-color: #8b5cf6 !important;\n  transform: scale(1.05) !important;\n  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3) !important;\n}\n\n.profile-icon:focus {\n  outline: none !important;\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.3) !important;\n}\n\n@media (min-width: 1160px) and (max-width: 1280px) {\n  .navbar-expand-sm .navbar-nav.main-menu .nav-link {\n    font-size: 14px !important;\n  }\n\n  .navbar-brand img {\n    width: 205px !important;\n  }\n\n  .user-greeting {\n    font-size: 13px !important;\n    margin-right: 0px !important;\n  }\n\n  .navbar-expand-sm .navbar-nav.main-menu .nav-link {\n    padding: 0 13px !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .navbar-expand-sm .navbar-nav.main-menu .nav-link {\n    font-size: 11px;\n    font-weight: var(--font-semibold);\n    padding: 0 8px;\n  }\n\n  .user-greeting {\n    font-size: var(--font-x-size-small) !important;\n    margin-right: 0px !important;\n  }\n\n  .login-link {\n    font-size: var(--font-size-small) !important;\n  }\n\n  .navbar {\n    height: 75px;\n  }\n\n  .navbar-brand img {\n    width: 175px;\n  }\n\n  /* Tablet User Greeting */\n  .user-greeting {\n    font-size: var(--font-size-small);\n    margin-right: 4px;\n  }\n\n  /* Constrain login button on tablets */\n  .navbar .btn.btn-primary {\n    font-size: 12px;\n    padding: 6px 14px;\n  }\n\n  .navbar .btn.btn-primary-app {\n    font-size: 12px;\n    padding: 6px 14px;\n  }\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .btn-primary-app {\n    padding: 8px 21px;\n    font-size: 11px !important;\n  }\n\n  .btn-download-mobile-app {\n    font-size: 10px !important;\n    padding: 6px 14px !important;\n    margin-left: auto;\n    margin-right: 10px;\n  }\n\n  .btn-download-mobile-app {\n    font-size: 10px !important;\n    padding: 10px 10px !important;\n    margin-left: auto;\n    margin-right: 10px;\n  }\n\n\n  .navbar {\n    transition: all 0.3s ease;\n    padding: 1rem 0;\n    background: var(--bg-white) !important;\n    border-radius: 17px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    width: 97%;\n    height: 72px;\n    position: fixed;\n    top: 5px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1000;\n    padding: 0px 10px 0px 16px;\n  }\n\n  .navbar-brand img {\n    width: 300px;\n  }\n\n  /* Mobile Menu Icon */\n  .navbar-toggler {\n    display: block !important;\n    border: none;\n    background: transparent;\n    padding: 8px;\n    margin-right: 10px;\n  }\n\n  .navbar-toggler:focus {\n    box-shadow: none;\n    outline: none;\n  }\n\n  .navbar-toggler-icon {\n    width: 24px;\n    height: 24px;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 0, 0, 0.8)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n\n  /* Mobile Menu Section */\n  .navbar-collapse {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: var(--bg-white);\n    border-radius: 17px 17px 17px 17px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    margin-top: 6px;\n  }\n\n  .navbar-nav {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .navbar-nav .nav-item {\n    margin: 2px 0;\n    text-align: center;\n  }\n\n  .navbar-nav .nav-link {\n    font-size: var(--font-size-medium);\n    font-weight: var(--font-semibold);\n    color: var(--text-black);\n    padding: 12px 20px;\n    border-radius: 25px;\n    transition: all 0.3s ease;\n  }\n\n  .navbar-nav .nav-link:hover {\n    color: var(--text-primary);\n    background: rgba(99, 24, 198, 0.1);\n  }\n\n  /* Mobile active navigation link styling */\n  .navbar-nav .nav-link.active {\n    color: var(--text-primary) !important;\n    background: rgba(99, 24, 198, 0.1) !important;\n    transform: none;\n  }\n\n  /* Mobile Login and Demo Button */\n  .navbar-nav.ms-auto {\n    margin-top: 10px;\n    /* border-top: 1px solid rgba(0, 0, 0, 0.1); */\n    padding-top: 0;\n  }\n\n  .navbar-nav.ms-auto .nav-item {\n    padding: 10px 0;\n  }\n\n  .login-link {\n    font-size: var(--font-size-medium) !important;\n    font-weight: var(--font-semibold);\n    color: var(--text-primary) !important;\n    background-color: transparent !important;\n    border: 2px solid var(--text-primary);\n    border-radius: 25px;\n    padding: 10px 20px !important;\n    display: block;\n    text-align: center;\n    transition: all 0.3s ease;\n    width: 50%;\n  }\n\n  .mn-auto {\n    display: flex;\n    justify-content: center;\n  }\n\n  .login-link:hover {\n    color: var(--bg-white) !important;\n    background-color: var(--text-primary) !important;\n  }\n\n  /* Mobile active login link styling */\n  .login-link.active {\n    color: var(--bg-white) !important;\n    background-color: var(--text-primary) !important;\n  }\n\n  .btn-demo {\n    background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) !important;\n    color: var(--text-white) !important;\n    border: none;\n    border-radius: 25px;\n    padding: 12px 24px !important;\n    font-size: var(--font-size-medium);\n    font-weight: var(--font-semibold);\n    display: block;\n    text-align: center;\n    text-decoration: none;\n    transition: all 0.3s ease;\n  }\n\n  .btn-demo:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(99, 24, 198, 0.3);\n  }\n\n  /* Mobile Profile Icon */\n  .profile-icon {\n    width: 36px !important;\n    height: 36px !important;\n    font-size: 16px !important;\n    margin-left: 4px !important;\n  }\n\n  /* Mobile User Greeting */\n  .user-greeting {\n    font-size: var(--font-size-small);\n    margin-right: 4px;\n  }\n\n  /* Center the greeting and profile icon on mobile */\n  .navbar-nav .nav-item.d-flex {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .download-buttons-container {\n    margin-top: 10px;\n    margin-bottom: 5px;\n  }\n}\n\n.download-btn {\n  display: flex;\n  align-items: center;\n  transition: transform 0.2s ease;\n  text-decoration: none;\n}\n\n.download-btn:hover {\n  transform: scale(1.05);\n}\n\n.download-icon {\n  height: 28px;\n  width: auto;\n  display: block;\n}\n\n@media (max-width: 991px) {\n  .download-icon {\n    height: 26px;\n  }\n}\n\n@media (max-width: 767px) {\n  .download-buttons-container {\n    justify-content: center;\n    width: 100%;\n    margin-right: 0 !important;\n  }\n\n  .download-icon {\n    height: 24px;\n  }\n}\n\n@media (max-width: 575px) {\n  .navbar {\n    transition: all 0.3s ease;\n    padding: 1rem 0;\n    background: var(--bg-white) !important;\n    border-radius: 17px;\n    /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);\n    width: 97%;\n    height: 56px;\n    position: fixed;\n    top: 5px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1000;\n    padding: 0px 0px 0px 5px;\n  }\n\n  .navbar-brand img {\n    width: 130px;\n  }\n\n  .navbar-brand {\n    padding-top: 0 !important;\n  }\n\n  /* Mobile Menu Icon */\n  .navbar-toggler {\n    display: block !important;\n    border: none;\n    background: transparent;\n    padding: 6px;\n    margin-right: 0px;\n  }\n\n  .navbar-toggler-icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  /* Mobile Menu Section */\n  .navbar-collapse {\n    padding: 15px;\n  }\n\n  .navbar-nav .nav-link {\n    font-size: var(--font-15) !important;\n    padding: 10px 16px;\n  }\n\n  .login-link {\n    font-size: var(--font-size-small) !important;\n    padding: 8px 16px !important;\n  }\n\n  .btn-demo {\n    font-size: var(--font-size-small);\n    padding: 10px 20px !important;\n  }\n\n  /* Mobile Profile Icon */\n  .profile-icon {\n    width: 32px !important;\n    height: 32px !important;\n    font-size: 14px !important;\n    margin-left: 4px !important;\n  }\n\n  /* Mobile User Greeting */\n  .user-greeting {\n    font-size: var(--font-size-small);\n    margin-right: 4px;\n  }\n\n  /* Center the greeting and profile icon on mobile */\n  .navbar-nav .nav-item.d-flex {\n    justify-content: center;\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
